import { useRef, useState } from 'react'

// Einfaches Unterschriften-Canvas -- kein externes Signatur-Paket noetig (Standard Pointer-
// Events-API), wiederverwendbar fuer Auftraggeber UND Auftragnehmer (TQ #18899/#18900).

interface Props {
  label: string
  onDone: (pngBase64: string) => void
}

export function SignatureCanvas({ label, onDone }: Props) {
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const drawingRef = useRef(false)
  const [hasDrawn, setHasDrawn] = useState(false)

  function getContext(): CanvasRenderingContext2D | null {
    return canvasRef.current?.getContext('2d') ?? null
  }

  function pointerPos(e: React.PointerEvent<HTMLCanvasElement>): { x: number; y: number } {
    const rect = e.currentTarget.getBoundingClientRect()
    return { x: e.clientX - rect.left, y: e.clientY - rect.top }
  }

  function handlePointerDown(e: React.PointerEvent<HTMLCanvasElement>) {
    e.currentTarget.setPointerCapture(e.pointerId)
    drawingRef.current = true
    const ctx = getContext()
    if (!ctx) return
    const { x, y } = pointerPos(e)
    ctx.beginPath()
    ctx.moveTo(x, y)
  }

  function handlePointerMove(e: React.PointerEvent<HTMLCanvasElement>) {
    if (!drawingRef.current) return
    const ctx = getContext()
    if (!ctx) return
    const { x, y } = pointerPos(e)
    ctx.lineWidth = 3
    ctx.lineCap = 'round'
    ctx.strokeStyle = '#0f172a'
    ctx.lineTo(x, y)
    ctx.stroke()
    setHasDrawn(true)
  }

  function handlePointerUp() {
    drawingRef.current = false
  }

  function clear() {
    const canvas = canvasRef.current
    const ctx = getContext()
    if (!canvas || !ctx) return
    ctx.clearRect(0, 0, canvas.width, canvas.height)
    setHasDrawn(false)
  }

  function done() {
    const canvas = canvasRef.current
    if (!canvas) return
    // dataURL-Praefix ("data:image/png;base64,") abschneiden -- der Server erwartet reines
    // Base64 (siehe models::signatur in stempel-api).
    const dataUrl = canvas.toDataURL('image/png')
    const base64 = dataUrl.split(',')[1]
    onDone(base64)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <p>{label}</p>
      <canvas
        ref={canvasRef}
        width={360}
        height={180}
        style={{ background: '#f8fafc', borderRadius: 8, touchAction: 'none' }}
        onPointerDown={handlePointerDown}
        onPointerMove={handlePointerMove}
        onPointerUp={handlePointerUp}
        onPointerLeave={handlePointerUp}
      />
      <div className="button-row">
        <button className="button button-secondary" onClick={clear}>
          Löschen
        </button>
        <button className="button button-in" disabled={!hasDrawn} onClick={done}>
          Fertig
        </button>
      </div>
    </div>
  )
}
